import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';

import { getBillingTermsQueryKey } from './useBillingTerms';

type RemoveBillingTermParams = {
  id: number;
};

async function removeBillingTerm({ id }: RemoveBillingTermParams): Promise<void> {
  await remove(`/api/organization/billing-terms/${id}`);
}

/**
 * Hook to remove a billing term for the current organization.
 * @returns Mutation function to remove a billing term
 */
export const useRemoveBillingTerm = () => {
  return useToastedMutation({
    mutationFn: removeBillingTerm,
    successToastMessage: 'Billing term removed successfully',
    errorToastMessage: 'Failed to remove billing term',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBillingTermsQueryKey() });
    },
  });
};
